import React from 'react';
import { Link } from 'react-router-dom';

export default (close) => (
  <div className="mobile-menu">
    <ul>
      <li className="menu-menu-small-text">Licenciaturas</li>
      <ul className="mob-ul">
        <li>
          <span className="menu-small-text">
            <a href="http://www.dei.uc.pt/ldm" target="_blank" rel="noopener noreferrer">
              Design e Multimédia
            </a>
          </span>
        </li>
        <li>
          <span className="menu-small-text">
            <a href="http://www.dei.uc.pt/lecd" target="_blank" rel="noopener noreferrer">
              Engenharia e Ciência de Dados
            </a>
          </span>
        </li>
        <li>
          <span className="menu-small-text">
            <a href="http://www.dei.uc.pt/lei" target="_blank" rel="noopener noreferrer">
              Engenharia Informática
            </a>
          </span>
        </li>
      </ul>
      —<li className="menu-menu-small-text">Mestrados</li>
      <ul className="mob-ul">
        <li>
          <span className="menu-small-text">
            <a href="http://www.dei.uc.pt/mdm" target="_blank" rel="noopener noreferrer">
              Design e Multimédia
            </a>
          </span>
        </li>
        <li>
          <span className="menu-small-text">
            <a href="http://www.dei.uc.pt/mse" target="_blank" rel="noopener noreferrer">
              Engenharia de Software
            </a>
          </span>
        </li>
        <li>
          <span className="menu-small-text">
            <a href="http://www.dei.uc.pt/mecd" target="_blank" rel="noopener noreferrer">
              Engenharia e Ciência de Dados
            </a>
          </span>
        </li>

        <li>
          <span className="menu-small-text">
            <a href="http://www.dei.uc.pt/mei" target="_blank" rel="noopener noreferrer">
              Engenharia Informática
            </a>
          </span>
        </li>

        <li>
          <span className="menu-small-text">
            <a href="http://www.dei.uc.pt/msi" target="_blank" rel="noopener noreferrer">
              Segurança Informática
            </a>
          </span>
        </li>
      </ul>
      —<li className="menu-menu-small-text">Doutoramentos</li>
      <ul className="mob-ul">
        <li>
          <span className="menu-small-text">
            <a href="http://www.dei.uc.pt/pdcti" target="_blank" rel="noopener noreferrer">
              Ciências e Tecnologias da Informação
            </a>
          </span>
        </li>
      </ul>
      —<li className="menu-menu-small-text">Formação Avançada</li>
      <p className="normal-text">Não conferente de grau</p>
      <ul className="mob-ul">
        <li>
          <span className="menu-small-text">
            <a href="https://acertarorumo.pt/" target="_blank" rel="noopener noreferrer">
              Acertar o Rumo
            </a>
          </span>
        </li>
        <li>
          <span className="menu-small-text">
            <a href="http://www.dei.uc.pt/pc1/?en" target="_blank" rel="noopener noreferrer">
              Programação Competitiva I
            </a>
          </span>
        </li>
      </ul>
      <br />—
      <li className="menu-small-text" onClick={close}>
        <Link to="/estrutura-do-programa">Estrutura do Programa</Link>
      </li>
      <li className="menu-small-text" onClick={close}>
        <Link to="/selecao-de-formandos">Seleção de Formandos</Link>
      </li>
      <li className="menu-small-text" onClick={close}>
        <Link to="/empresas-aderentes">Empresas Aderentes</Link>
      </li>
      <li className="menu-small-text" onClick={close}>
        <Link to="/testemunhos">Testemunhos</Link>
      </li>
    </ul>

    <ul className="show-pc">
      —
      <li className="menu-small-text" onClick={close}>
        <Link to="/noticias">Notícias</Link>
      </li>
      <li className="menu-small-text" onClick={close}>
        <Link to="/videos">Vídeos</Link>
      </li>
      <li className="menu-small-text" onClick={close}>
        <Link to="/faqs">FAQs</Link>
      </li>
      <li className="menu-small-text">
        <a href="https://www.facebook.com/AcertarORumo/" target="_blank" rel="noopener noreferrer">
          Facebook
        </a>
      </li>
      <li className="menu-small-text">
        <a href="mailto:info@acertarorumo.pt" target="_blank" rel="noopener noreferrer">
          info@acertarorumo.pt
        </a>
      </li>
    </ul>
  </div>
);
